import { render } from "./ClientInfo.vue?vue&type=template&id=41d8fe1c&scoped=true"
import script from "./ClientInfo.vue?vue&type=script&lang=js"
export * from "./ClientInfo.vue?vue&type=script&lang=js"

import "./ClientInfo.vue?vue&type=style&index=0&id=41d8fe1c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41d8fe1c"]])

export default __exports__